// TODO: Move this back here
// import 'magnific-popup/dist/jquery.magnific-popup.min.js';
// import '@accessible360/accessible-slick/slick/slick.min.js';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

jQuery('.js-slider').slick(
  {
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 650,
    infinite: true,
    // TODO: Replace font icon with svg
    prevArrow: '<button class="slick__button slick__button--back"><span class="sr-only">' + jQuery('.js-slider').attr('data-previous') + '</span><i class="slick__icon icon-arrow-left" aria-hidden="true"></i></button>',
    nextArrow: '<button class="slick__button slick__button--next"><span class="sr-only">' + jQuery('.js-slider').attr('data-next') + '</span><i class="slick__icon icon-arrow-right" aria-hidden="true"></i></button>',
    // autoplay: true,
    dots: true,
    autoplaySpeed: 3900,
  }
);

/**
 * Video Popup
 */

jQuery('.js-video').magnificPopup({
    type: 'iframe',
    enableEscapeKey: 'true',
    iframe: {
      markup: '<div class="mfp-iframe-scaler">' +
        '<button class="mfp-close">Close</button>' +
        '<iframe class="mfp-iframe" frameborder="0" allow="autoplay" allowfullscreen="true"></iframe>' +
        '</div>',
      patterns: {
        youtube: {
          index: 'youtube.com/',
          id: 'v=',
          src: 'https://www.youtube-nocookie.com/embed/%id%?vq=hd1080&autoplay=1&modestbranding=1&rel=0',
        },
        youtube2: {
          index: 'youtu.be/',
          id: '/',
          src: 'https://www.youtube-nocookie.com/embed/%id%?vq=hd1080&autoplay=1&modestbranding=1&rel=0',
        },
        vimeo: {
          index: 'vimeo.com/',
          id: '/',
          src: 'https://player.vimeo.com/video/%id%?autoplay=true'
        }
      },
    },
  }
)

jQuery('.js-slider').magnificPopup({
    delegate: 'a', // child items selector, by clicking on it popup will open
    type: 'image',
    enableEscapeKey: 'true',
    gallery: {
      enabled: true,
    },
    image: {
      titleSrc: 'title',
    },
    tLoading: jQuery(this).data('loading'),
  }
)

jQuery('.js-gallery').magnificPopup({
    delegate: 'a', // child items selector, by clicking on it popup will open
    type: 'image',
    enableEscapeKey: 'true',
    gallery: {
      enabled: true,
    },
    image: {
      titleSrc: 'title',
    },
    tLoading: jQuery(this).data('loading'),
  }
)

// Cookie Complianz - Source: https://complianz.io/add-a-link-to-show-the-cookie-banner/
addCmplzEvent('click', '.js-cmplz-banner-show', function (e) {
  e.preventDefault();
  document.querySelectorAll('.cmplz-manage-consent').forEach(obj => {
    obj.click();
  });
});


/**
 *  Dashboard
 */
// Open Contact Form
jQuery('.js-open-contact-form').on('click', function (e) {
  e.preventDefault();
  jQuery('.js-contact-form').show();
})

// Close Contact Form
jQuery('.js-contact-form-close').on('click', function (e) {
  e.preventDefault();
  jQuery('.js-contact-form').hide();
})

document.addEventListener('keydown', (e) => {
  if (e.keyCode == 27) {
    jQuery('.js-contact-form').hide();
  }
});

// Functions
function addCmplzEvent(event, selector, callback) {
  document.addEventListener(event, e => {
    if (e.target.closest(selector)) {
      callback(e);
    }
  });
}

/**
Polylang
 */
const $langSwitcherToggleButton = jQuery('.js-lang-switcher-toggle');
const $langSwitcher = jQuery('.lang-switcher');

// Function to toggle the language selector visibility
function toggleLangSelect(show) {
  const expanded = show ? 'true' : 'false';
  $langSwitcherToggleButton.attr('aria-expanded', expanded);
}

// Event listener for keyboard interaction
$langSwitcherToggleButton.on('keydown', function(event) {
  if (event.key === ' ' || event.key === 'Enter') {
    event.preventDefault();
    const isExpanded = $langSwitcherToggleButton.attr('aria-expanded') === 'true';
    toggleLangSelect(!isExpanded);
  }
});

// Event listeners for mouse hover
$langSwitcher.on('mouseenter', function() {
  toggleLangSelect(true);
});

$langSwitcher.on('mouseleave', function() {
  toggleLangSelect(false);
});
